import useSWR from "swr";
import useAuth from "./useAuth";
import { getFetcher } from "../services/api";

export default function useListCompany(filters = {}) {
  const { user, isSuperAdmin } = useAuth();

  // Build query params
  const buildQueryParams = () => {
    const params = new URLSearchParams();
    params.append("returnAll", "true");
    params.append("sortOrder", "desc");

    /*
     * Secara bawaan pengguna non-super-admin hanya melihat perusahaannya
     * sendiri. `semuaPerusahaan` membuka batas itu untuk kasus di mana yang
     * dicari memang perusahaan LAIN - mis. memilih pemasok pada pembelian
     * lokal, yang menurut definisinya bukan perusahaan pelapor.
     */
    if (!isSuperAdmin && !filters.semuaPerusahaan) {
      const companyIds = user.companies?.map((company) => company.companyId).join(",") || "";
      params.append("companyIds", companyIds);
    }

    // Add filters
    if (filters.isTidakMelakukanPengelolaanB3 !== undefined) {
      params.append("isTidakMelakukanPengelolaanB3", filters.isTidakMelakukanPengelolaanB3.toString());
    }

    /*
     * Saring menurut tipe perusahaan bila pemanggil memintanya.
     *
     * Bukan sekadar kerapian: tanpa filter, endpoint ini mengembalikan SELURUH
     * 8.585 perusahaan - 10,2 MB dan ~2,5 detik - hanya untuk mengisi satu
     * dropdown. Menyaring ke tipe yang relevan memangkasnya drastis (mis.
     * "Mengangkut B3" menjadi 243 perusahaan, 346 KB, ~130 ms).
     */
    if (filters.tipePerusahaan?.length > 0) {
      params.append("tipePerusahaan", filters.tipePerusahaan.join(","));
    }

    // Hanya perusahaan yang sudah tertaut SIMPEL. Ikut memangkas muatan, tapi
    // alasan utamanya kelayakan: perusahaan tanpa idCompanySimpel belum
    // terdaftar di SIMPEL.
    if (filters.hasIdCompanySimpel !== undefined) {
      params.append("hasIdCompanySimpel", filters.hasIdCompanySimpel.toString());
    }

    return params.toString();
  };

  const { data, isLoading, mutate } = useSWR(`/api/company/search-company?${buildQueryParams()}`, getFetcher);

  return { dataCompany: data, isLoadingCompany: isLoading, mutate };
}
